<script>
    // HUD v2 «Emerald» — правый верхний блок: бренд, онлайн, ID, патроны,
    // розыск, бонус-баннер. Логика/сеттеры сохранены 1-в-1 со старым.
    import { serverDonatMultiplier, serverOnline, serverPlayerId } from 'store/server'
    import { charWanted, charUUID } from 'store/chars'
    import { fly } from 'svelte/transition';
    import moment from 'moment'
    export let selectCharData;
    import { reportsData, text } from '../../../player/reports/index'
    import { translateText } from 'lang'
    import { onDestroy } from 'svelte'

    let isCase = true,
        caseId = -1;

    const caseData = [
        { color: "green", image: "250", hour: translateText ('player2', '3 часа ')},
        { color: "yellow", image: "251", hour: translateText ('player2', '5 часов') },
        { color: "red", image: "252", hour: translateText ('player2', '8 часов')},
    ]

    window.updateCase = (_caseId) => {
        if (caseId === _caseId) return;
        isCase = true;
        caseId = _caseId;
    }

    let reports = [],
        answer = $text;

    onDestroy(() => {
        text.set(answer)
    });

    reportsData.subscribe(value => {
        reports = value;
    });

    let serverName = "";
    window.setServerName = (name) => serverName = name;

    // ID и онлайн — из store/server (единый источник, без перехвата сеттеров)

    let weaponItemId = 0;
    window.hudStore.weaponItemId = (value) => weaponItemId = value;

    let clipSize = 0;
    window.hudStore.clipSize = (value) => clipSize = value;

    let ammo = 0;
    window.hudStore.ammo = (value) => ammo = value;

    let isShow = false;
    let donatMult = 1;

    serverDonatMultiplier.subscribe(value => {
        donatMult = value;
        if (value > 1) {
            isShow = true;
            setTimeout(() => { isShow = false; }, 1000 * 30);
        }
    });

    var activities = {}
</script>

<div class="magicserver">
    <div class="hudevo__activities">
        {#each Object.values(activities) as item, index }
            <div class="hudevo__activities_block" class:isdeff="{ item.IsDeff === true }">
                <h1>{ item.Name }</h1>
                <p>{ item.Time }</p>
            </div>
        {/each}
    </div>

    <!-- единая карточка: бренд / статус / бонус -->
    <div class="jrh-card">
        <div class="jrh-card-head">
            <span class="jr">J<i>R</i></span>
            <div class="jrh-brand-info">
                <b>JUST RP</b>
                <p>Online <b>{$serverOnline}</b> · RU1</p>
            </div>
            <div class="jrh-id">
                <span>ID {$serverPlayerId}</span>
                <b>#{$charUUID || selectCharData.UUID || 0}</b>
            </div>
        </div>

        {#if selectCharData.isAdmin || isShow || ammo > 0 || $charWanted > 0}
            <div class="jrh-card-row">
                {#if selectCharData.isAdmin}
                    <div class="jrh-pill warn" title="Репорты">
                        <svg viewBox="0 0 24 24"><path d="M20 12.5c0 3.6-3.6 6.5-8 6.5-1 0-2-.2-2.9-.4L5 20l1-3.2C4.7 15.6 4 14.1 4 12.5 4 8.9 7.6 6 12 6s8 2.9 8 6.5Z" stroke="currentColor" stroke-width="1.7" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        <b>{reports.length}</b>
                    </div>
                {/if}
                {#if isShow}
                    <div class="jrh-pill gold" transition:fly={{ x: 30, duration: 250 }}>
                        <svg viewBox="0 0 24 24"><path d="M12 3l2.4 5 5.6.7-4.1 3.8 1.1 5.5L12 15.4 7 18l1.1-5.5L4 8.7 9.6 8 12 3Z" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linejoin="round"/></svg>
                        <b>x{donatMult}</b>
                    </div>
                {/if}
                {#if ammo > 0}
                    <div class="jrh-pill" transition:fly={{ x: 30, duration: 200 }} title="Патроны">
                        <svg viewBox="0 0 24 24"><path d="M9 21h6M10 18h4V9.5L12.8 7V4.5c0-.9-.4-1.8-.8-2.2-.4.4-.8 1.3-.8 2.2V7L10 9.5V18Z" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linejoin="round"/></svg>
                        <b>{ammo}</b>
                        {#if clipSize > 0 && clipSize < 1000}<span>/{clipSize}</span>{/if}
                    </div>
                {/if}
                {#if $charWanted > 0}
                    <div class="jrh-wanted" transition:fly={{ x: 30, duration: 200 }}>
                        {#each new Array(6) as e, i}
                            <svg class="star" class:on={i < $charWanted} viewBox="0 0 22 20">
                                <path d="M11 0L14.1682 6.6394L21.4616 7.60081L16.1262 12.6656L17.4656 19.8992L11 16.39L4.53436 19.8992L5.87381 12.6656L0.538379 7.60081L7.83184 6.6394L11 0Z"/>
                            </svg>
                        {/each}
                    </div>
                {/if}
            </div>
        {/if}

        {#if isCase}
            <div class="jrh-card-bonus">
                <div class="jrh-bonus-ico">
                    <svg viewBox="0 0 24 24"><path d="M4 8h16v4H4zM6 12v8h12v-8M12 8v12M12 8c-2.5 0-4-1-4-2.5C8 4 9.5 3.5 10.5 4.2 11.5 4.9 12 6.5 12 8ZM12 8c2.5 0 4-1 4-2.5C16 4 14.5 3.5 13.5 4.2 12.5 4.9 12 6.5 12 8Z" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </div>
                <div class="jrh-bonus-text">
                    <h1>Кейс + 50 JC за 3 часа игры</h1>
                    {#if selectCharData.TodayTime < 180}
                        <p>Осталось: <b>{moment.duration(180 - selectCharData.TodayTime, "minutes").format("h[ч.] m[м.]")}</b></p>
                    {:else}
                        <p>Награда за сегодня: <b>получена!</b></p>
                    {/if}
                </div>
            </div>
        {/if}
    </div>
</div>

<style>
    .magicserver {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-end;
        gap: 0.65vh;
        margin-top: 1.85vh;
        margin-right: 1.1vh;
        font-family: 'Gilroy', 'SF Pro Display', sans-serif;
    }

    /* ===== единая карточка ===== */
    .jrh-card {
        width: 26vh;
        background: rgba(5, 20, 12, 0.6);
        border: 1px solid rgba(140, 255, 190, 0.16);
        border-radius: 1.1vh;
        backdrop-filter: blur(10px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
        box-sizing: border-box;
        overflow: hidden;
    }

    .jrh-card-head {
        display: flex; align-items: center; gap: 1vh;
        padding: 1vh 1.2vh;
    }
    .jrh-card-head .jr {
        font-weight: 900; font-style: italic; font-size: 2.5vh; line-height: 1;
        letter-spacing: -0.04em;
        background: linear-gradient(135deg, #ffffff 20%, #b9ffd6 60%, #36e07c 100%);
        -webkit-background-clip: text; background-clip: text; color: transparent;
        filter: drop-shadow(0 0 10px rgba(54, 224, 124, 0.45));
    }
    .jrh-card-head .jr i { font-style: italic; }
    .jrh-brand-info { min-width: 0; }
    .jrh-brand-info b { display: block; font-size: 1.25vh; font-weight: 800; letter-spacing: 0.16em; color: #ecfff3; }
    .jrh-brand-info p { margin: 0.15vh 0 0; font-size: 1.05vh; color: rgba(220, 248, 232, 0.55); }
    .jrh-brand-info p b { display: inline; font-size: 1.05vh; letter-spacing: 0; color: #36e07c; }
    .jrh-id { margin-left: auto; text-align: right; }
    .jrh-id span { display: block; font-size: 0.95vh; font-weight: 700; color: rgba(220, 248, 232, 0.5); }
    .jrh-id b { display: block; font-size: 1.3vh; font-weight: 900; color: #ecfff3; }

    .jrh-card-row {
        display: flex; align-items: center; gap: 0.6vh; flex-wrap: wrap;
        padding: 0.8vh 1.2vh;
        border-top: 1px solid rgba(140, 255, 190, 0.1);
    }
    .jrh-pill {
        display: flex; align-items: baseline; gap: 0.45vh;
        padding: 0.45vh 0.9vh;
        background: rgba(140, 255, 190, 0.07);
        border: 1px solid rgba(140, 255, 190, 0.16);
        border-radius: 2vh;
        color: #ecfff3;
    }
    .jrh-pill svg { width: 1.5vh; height: 1.5vh; color: #36e07c; align-self: center; }
    .jrh-pill b { font-size: 1.2vh; font-weight: 900; }
    .jrh-pill span { font-size: 1vh; color: rgba(220, 248, 232, 0.5); font-weight: 700; }
    .jrh-pill.warn { border-color: rgba(255, 92, 92, 0.35); background: rgba(255, 92, 92, 0.08); }
    .jrh-pill.warn svg { color: #ff8a80; }
    .jrh-pill.gold { border-color: rgba(255, 209, 102, 0.35); background: rgba(255, 209, 102, 0.08); }
    .jrh-pill.gold svg { color: #ffd166; }
    .jrh-pill.gold b { color: #ffe2a1; }

    .jrh-wanted { display: flex; gap: 0.3vh; margin-left: auto; }
    .jrh-wanted .star { width: 1.7vh; height: 1.55vh; }
    .jrh-wanted .star path { fill: rgba(236, 255, 243, 0.16); transition: fill 0.25s, filter 0.25s; }
    .jrh-wanted .star.on path { fill: #ffd166; }
    .jrh-wanted .star.on { filter: drop-shadow(0 0 7px rgba(255, 209, 102, 0.65)); }

    .jrh-card-bonus {
        display: flex; align-items: center; gap: 1.1vh;
        padding: 0.9vh 1.2vh;
        border-top: 1px solid rgba(140, 255, 190, 0.1);
        background: linear-gradient(110deg, rgba(20, 90, 48, 0.35), transparent 70%);
    }
    .jrh-bonus-ico {
        width: 3.2vh; height: 3.2vh; flex: 0 0 auto;
        display: flex; align-items: center; justify-content: center;
        border-radius: 0.9vh;
        background: rgba(54, 224, 124, 0.14);
        color: #36e07c;
    }
    .jrh-bonus-ico svg { width: 2vh; height: 2vh; }
    .jrh-bonus-text h1 { margin: 0; font-size: 1.15vh; font-weight: 800; color: #ecfff3; letter-spacing: 0.02em; }
    .jrh-bonus-text p { margin: 0.25vh 0 0; font-size: 1.05vh; color: rgba(220, 248, 232, 0.55); }
    .jrh-bonus-text p b { color: #36e07c; font-weight: 800; }
</style>
